var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowblackLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.74221 6.00098L0.296055 1.55482C0.202472 1.46124 0.152472 1.36733 0.146055 1.2731C0.139639 1.17887 0.189639 1.07854 0.296055 0.972125C0.402472 0.865709 0.499588 0.8125 0.587405 0.8125C0.675222 0.8125 0.775155 0.868533 0.887205 0.9806L5.41721 5.5106C5.48772 5.58777 5.54061 5.66603 5.57588 5.7454C5.61113 5.82475 5.62876 5.91161 5.62876 6.00598C5.62876 6.10034 5.61113 6.1872 5.57588 6.26655C5.54061 6.34592 5.48772 6.42085 5.41721 6.49135L0.887205 11.0213C0.787988 11.1206 0.69543 11.1692 0.60953 11.1673C0.52363 11.1654 0.427472 11.1112 0.321055 11.0048C0.214639 10.8984 0.16143 10.8013 0.16143 10.7135C0.16143 10.6257 0.214639 10.5285 0.321055 10.4221L4.74221 6.00098Z",
    fill: "#00838F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowblackLeft);
export default __webpack_public_path__ + "static/media/arrowblack_left.1167a8515bf02c3f9908e4463dae672c.svg";
export { ForwardRef as ReactComponent };